import fingertipsLinks from '../data/dashboard/fingertipLinks.json';
import companies from '../data/dashboard/companies.json';
import otherCompanyBenefits from '../data/dashboard/otherCompanyBenefits.json';

export const getFingertipsLinks = (persona: string): any[] => {
  const data: any = fingertipsLinks['data'];
  return data[persona] || [];
};

export const getAllCompanies = (persona: string): any[] => {
  const data: any = companies['data'];
  return data[persona] || [];
};

export const getOtherCompanyBenefits = (): any[] => {
  return otherCompanyBenefits['data'] || [];
};
